module.exports = __webpack_public_path__ + "static/img/stemcell.7949a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stemcell.png
// module id = i/ma
// module chunks = 1